// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"134":"1a069466","499":"cb21cf1d","503":"4a3ac0d8","540":"c2a22ee0","572":"ab424fcb","607":"776c4938","648":"ca73c978","707":"efa38f3c","912":"bef28aee","961":"4591f6c0"}[chunkId] + ".chunk.js";
};